import "core-js/modules/es.json.stringify.js";
import store from '@/store';
import router from '@/router';
import request from '@/request';
import ErrorCode from '@/request/error-code';
import { ElLoading } from 'element-plus';
// import cacheSessionStorage from '../cache/cacheSessionStorage'
import cacheInLocalStorage from '../cache/cacheInLocalStorage';
var getters = {
  token_temp: function token_temp(state) {
    return state.token_temp;
  },
  username_temp: function username_temp(state) {
    return state.username_temp;
  },
  token: function token(state) {
    return state.token;
  },
  role: function role(state) {
    return state.role;
  },
  userinfo: function userinfo(state) {
    return state.userinfo;
  },
  userPermission: function userPermission(state) {
    return state.userPermission;
  },
  requestsBeforeLogout: function requestsBeforeLogout(state) {
    return state.requestsBeforeLogout;
  }
};
var state = {
  token_temp: '',
  username_temp: '',
  token: cacheInLocalStorage.get('token'),
  role: cacheInLocalStorage.get('role'),
  userinfo: cacheInLocalStorage.get('userinfo'),
  userPermission: cacheInLocalStorage.get('userPermission'),
  requestsBeforeLogout: null
};
var mutations = {
  SET_TOKEN_TEMP: function SET_TOKEN_TEMP(state, token) {
    state.token_temp = token;
  },
  SET_USERNAME_TEMP: function SET_USERNAME_TEMP(state, username) {
    state.username_temp = username;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
    cacheInLocalStorage.set('token', token);
  },
  SET_ROLE: function SET_ROLE(state, role) {
    state.role = role;
    cacheInLocalStorage.set('role', role);
  },
  SET_INFO: function SET_INFO(state, info) {
    state.userinfo = info;
    cacheInLocalStorage.set('userinfo', info);
  },
  SET_USER_PERMISSION: function SET_USER_PERMISSION(state, permissions) {
    state.userPermission = permissions;
    cacheInLocalStorage.set('userPermission', permissions);
  },
  SET_REQUESTS_BEFORE_LOGOUT: function SET_REQUESTS_BEFORE_LOGOUT(state, infos) {
    state.requestsBeforeLogout = infos;
  }
};
var actions = {
  LOGIN: function LOGIN(_ref, _ref2) {
    var commit = _ref.commit;
    var data = _ref2.data,
      role = _ref2.role,
      username = _ref2.username,
      isNoRouter = _ref2.isNoRouter;
    return new Promise(function (resolve, reject) {
      request({
        url: '/auth/login',
        method: 'POST',
        data: data,
        headers: {
          ContentType: 'multipart/form-data'
        },
        hideErrorMessage: true
      }).then(function (res) {
        commit('SET_TOKEN', res);
        commit('SET_ROLE', role);
        resolve();
      }).catch(function (res) {
        commit('SET_TOKEN_TEMP', res.data);
        commit('SET_USERNAME_TEMP', username);
        commit('SET_ROLE', role);
        commit('SET_INFO', {
          userName: username
        });
        if (res.code === ErrorCode.ErrRequestNewUser) {
          if (!isNoRouter) {
            router.replace({
              path: '/pass-reset'
            });
          }
        } else if (res.code === ErrorCode.ErrRequestNeedUpdatePassword) {
          commit('SET_INFO', {
            userName: username
          });
          router.replace({
            path: '/pass-update'
          });
        } else if (res.code === ErrorCode.ErrRequestAccountTransfer) {
          cacheInLocalStorage.set('transferAuthorization', JSON.stringify(res.data));
          router.replace({
            path: '/account-transfer'
          });
        }
        reject(res);
      });
    });
  },
  LOGIN_WITH_NO_PASSWORD: function LOGIN_WITH_NO_PASSWORD(_ref3, _ref4) {
    var commit = _ref3.commit;
    var role = _ref4.role,
      username = _ref4.username,
      isNoRouter = _ref4.isNoRouter;
    return new Promise(function (resolve, reject) {
      request({
        url: '/api/v1/oauth/token/test',
        method: 'GET',
        params: {
          userName: username
        },
        headers: {
          ContentType: 'multipart/form-data'
        }
      }).then(function (res) {
        commit('SET_TOKEN', res);
        commit('SET_ROLE', role);
        resolve();
      }).catch(function (res) {
        commit('SET_TOKEN_TEMP', res.data);
        commit('SET_USERNAME_TEMP', username);
        commit('SET_ROLE', role);
        commit('SET_INFO', {
          userName: username
        });
        if (res.code === ErrorCode.ErrRequestNewUser) {
          if (!isNoRouter) {
            router.replace({
              path: '/pass-reset'
            });
          }
        } else if (res.code === ErrorCode.ErrRequestNeedUpdatePassword) {
          commit('SET_INFO', {
            userName: username
          });
          router.replace({
            path: '/pass-update'
          });
        } else if (res.code === ErrorCode.ErrRequestAccountTransfer) {
          cacheInLocalStorage.set('transferAuthorization', JSON.stringify(res.data));
          router.replace({
            path: '/account-transfer'
          });
        }
        reject(res);
      });
    });
  },
  LOGOUT: function LOGOUT(_ref5) {
    var commit = _ref5.commit;
    return new Promise(function (resolve) {
      var loadingInstance = ElLoading.service({
        lock: true,
        text: '正在退出...',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(function () {
        loadingInstance.close();
        commit('SET_TOKEN', '');
        store.commit('permission/SET_ROUTES', []);
        commit('SET_INFO', {});
        commit('SET_USER_PERMISSION', []);
        cacheInLocalStorage.remove('isEasyClearIdLogin');
        cacheInLocalStorage.remove('upsId');
        cacheInLocalStorage.remove('isB');
        cacheInLocalStorage.remove('staffInfo');
        resolve();
      }, 2000);
    });
  },
  GET_INFO_CUSTOMER: function GET_INFO_CUSTOMER(_ref6) {
    var commit = _ref6.commit;
    return new Promise(function (resolve) {
      request({
        url: '/api/v1/customer/profile',
        method: 'GET'
      }).then(function (res) {
        commit('SET_INFO', {
          userName: res.username,
          department: res.companyName,
          portCode: res.portCode,
          postalCode: res.postalCode,
          isLocked: res.isLocked ? res.isLocked : false,
          companyName: res.companyName,
          upsAccount: res.upsAccount,
          upsId: res.upsId,
          accountNo: res.accountNo
        });
        resolve(res);
      });
    });
  },
  GET_INFO_ADMIN: function GET_INFO_ADMIN(_ref7) {
    var commit = _ref7.commit;
    return new Promise(function (resolve, reject) {
      request({
        url: '/api/v1/staff/profile',
        method: 'GET',
        hideErrorMessage: true
      }).then(function (res) {
        console.log('GET_INFO_ADMIN=>staffInfo:', res);
        cacheInLocalStorage.set('staffInfo', JSON.stringify(res));
        commit('SET_INFO', {
          userName: res.staffId,
          department: res.roleList[0].roleCode,
          staffEmail: res.staffEmail,
          roleCode: res.roleList[0].roleCode,
          fixedRole: res.roleList[0].roleCode,
          sortNo: res.roleList[0].sortNo
        });
        resolve();
      }).catch(function () {
        reject();
      });
    });
  },
  getUserPermission: function getUserPermission(_ref8) {
    var commit = _ref8.commit;
    return new Promise(function (resolve) {
      request({
        url: '/api/v1/user-permissions',
        hideErrorMessage: true
      }).then(function (res) {
        commit('SET_USER_PERMISSION', res);
        resolve();
      });
    });
  },
  LOGOUT_CLEARN_DATAS: function LOGOUT_CLEARN_DATAS(_ref9) {
    var commit = _ref9.commit;
    commit('SET_TOKEN', '');
    store.commit('permission/SET_ROUTES', []);
    commit('SET_INFO', {});
    commit('SET_USER_PERMISSION', []);
    cacheInLocalStorage.remove('isEasyClearIdLogin');
    cacheInLocalStorage.remove('upsId');
    cacheInLocalStorage.remove('isB');
    cacheInLocalStorage.remove('staffInfo');
  }
};
export default {
  namespaced: true,
  getters: getters,
  state: state,
  mutations: mutations,
  actions: actions
};